export default __webpack_public_path__ + "static/media/restore-pink.50f6524f.svg";